import { version } from 'shiki/package.json';
import theme from './theme';

/**
 * We use this CDN ESM import to allow languages to be loaded at runtime and
 * avoid having to import a large bundle every time we load a page.
 *
 * Docs: https://shiki.style/guide/install#cdn-usage
 */
const shikiModule = `https://esm.sh/shiki@${version}`;

// eslint-disable-next-line import/prefer-default-export
export async function codeToHtml(code: string, lang: string) {
  const { codeToHtml: shikiCodeToHtml } = await import(/* @vite-ignore */ shikiModule);

  return shikiCodeToHtml(code, {
    lang,
    theme,
  });
}
